import {
  ROUTE_CATEGORIES_ALL,
  ROUTE_MENU,
  ROUTE_SERVICES,
  ROUTE_SHOP,
} from "@/utils/constants";
import { Merchant } from "@/dto/merchant";
import { Category } from "@/dto/category";
import { MerchantBusinessType } from "@/constants/enum";
import { SecondaryCarouselNavigationBar } from "@/components/secondaryCarouselNavigationBar/secondaryCarouselNavigationBar";
import { SecondaryServicesNavigationBar } from "./secondaryServicesNavigationBar";
import { giftCardCategory } from "@/utils/giftCardUtils";
import { filterRestaurantCategories } from "@/utils/itemUtils";

interface SecondaryNavigationProps {
  pathName: string | null;
  merchant: Merchant;
  hasHorizontalScrollFlag: boolean;
  retailCategories: Category[];
  serviceCategories: Category[];
  isScrolledDown?: boolean;
  mappedCategories: Category[];
  moreCategories: Category[];
  scanToOrderInfo: any;
  isNotAcceptingOrder: boolean;
  categories: Category[];
  restaurantMfeEnabled?: boolean;
}

export const SecondaryNavigation = ({
  pathName,
  merchant,
  hasHorizontalScrollFlag,
  retailCategories,
  serviceCategories,
  isScrolledDown,
  mappedCategories,
  moreCategories,
  scanToOrderInfo,
  isNotAcceptingOrder,
  categories,
  restaurantMfeEnabled = false,
}: SecondaryNavigationProps) => {
  const allowedRoutes = [
    ROUTE_SERVICES,
    ROUTE_MENU(restaurantMfeEnabled),
    ROUTE_SHOP,
    ROUTE_CATEGORIES_ALL,
  ];
  const hasBasicPath = allowedRoutes.some((path) => pathName?.includes(path));
  if (!hasBasicPath) {
    return null;
  }

  if (
    process.env.NEXT_PUBLIC_ALLOW_SHOP_AS_DEFAULT_RETAIL_ROUTE === "true" &&
    merchant.isRetail
  ) {
    return null;
  }
  const isRestaurantOrService =
    merchant.merchantBusinessType === MerchantBusinessType.RESTAURANT ||
    merchant.merchantBusinessType === MerchantBusinessType.SERVICE;
  if (isRestaurantOrService && hasHorizontalScrollFlag) {
    return (
      <SecondaryCarouselNavigationBar
        categories={getCarouselCategories({
          merchant,
          pathName,
          retailCategories,
          serviceCategories,
          categories,
        })}
        isScrolledDown={isScrolledDown}
      />
    );
  } else {
    const displayCategories = merchant?.isRestaurant
      ? filterRestaurantCategories(mappedCategories)
      : mappedCategories;
    const filteredMoreCategories = merchant?.isRestaurant
      ? filterRestaurantCategories(moreCategories)
      : moreCategories;
    return (
      <SecondaryServicesNavigationBar
        displayCategories={displayCategories}
        moreCategories={filteredMoreCategories}
        retailCategories={retailCategories}
        serviceCategories={serviceCategories}
        scanToOrderInfo={scanToOrderInfo}
        isNotAcceptingOrder={isNotAcceptingOrder}
      />
    );
  }
};
const getCarouselCategories = ({
  merchant,
  pathName,
  retailCategories,
  serviceCategories,
  categories,
}: {
  merchant: Merchant;
  pathName: string | null;
  retailCategories: Category[];
  serviceCategories: Category[];
  categories: Category[];
}): Category[] => {
  if (merchant.isHybrid) {
    return pathName?.includes(ROUTE_SHOP)
      ? retailCategories
      : serviceCategories.filter((c: Category) => c.id !== giftCardCategory.id);
  }
  return merchant?.isRestaurant
    ? filterRestaurantCategories(categories)
    : categories;
};
